var map = {
	"./ADR/ExternalLoginADR": [
		214,
		9
	],
	"./ADR/ExternalLoginADR/": [
		214,
		9
	],
	"./ADR/ExternalLoginADR/index": [
		214,
		9
	],
	"./ADR/ExternalLoginADR/index.jsx": [
		214,
		9
	],
	"./Access/Group/Create": [
		215,
		9
	],
	"./Access/Group/Create/": [
		215,
		9
	],
	"./Access/Group/Create/Create-documentation.md": [
		842,
		9
	],
	"./Access/Group/Create/index": [
		215,
		9
	],
	"./Access/Group/Create/index.js": [
		215,
		9
	],
	"./Access/Group/List": [
		216,
		9
	],
	"./Access/Group/List/": [
		216,
		9
	],
	"./Access/Group/List/List-documentation.md": [
		862,
		9
	],
	"./Access/Group/List/index": [
		216,
		9
	],
	"./Access/Group/List/index.js": [
		216,
		9
	],
	"./Access/Region/Create": [
		218,
		9
	],
	"./Access/Region/Create/": [
		218,
		9
	],
	"./Access/Region/Create/Create-documentation.md": [
		863,
		9
	],
	"./Access/Region/Create/index": [
		218,
		9
	],
	"./Access/Region/Create/index.js": [
		218,
		9
	],
	"./Access/Region/List": [
		219,
		9
	],
	"./Access/Region/List/": [
		219,
		9
	],
	"./Access/Region/List/List-documentation.md": [
		879,
		9
	],
	"./Access/Region/List/index": [
		219,
		9
	],
	"./Access/Region/List/index.js": [
		219,
		9
	],
	"./Access/Role/Create": [
		220,
		9
	],
	"./Access/Role/Create/": [
		220,
		9
	],
	"./Access/Role/Create/Create-documentation.md": [
		893,
		9
	],
	"./Access/Role/Create/index": [
		220,
		9
	],
	"./Access/Role/Create/index.js": [
		220,
		9
	],
	"./Access/Role/Create/styles.css": [
		686,
		7
	],
	"./Access/Role/List": [
		221,
		9
	],
	"./Access/Role/List/": [
		221,
		9
	],
	"./Access/Role/List/List-documentation.md": [
		894,
		9
	],
	"./Access/Role/List/index": [
		221,
		9
	],
	"./Access/Role/List/index.js": [
		221,
		9
	],
	"./Access/School/Create": [
		222,
		9
	],
	"./Access/School/Create/": [
		222,
		9
	],
	"./Access/School/Create/Create-documentation.md": [
		895,
		9
	],
	"./Access/School/Create/index": [
		222,
		9
	],
	"./Access/School/Create/index.js": [
		222,
		9
	],
	"./Access/School/List": [
		223,
		9
	],
	"./Access/School/List/": [
		223,
		9
	],
	"./Access/School/List/List-documentation.md": [
		896,
		9
	],
	"./Access/School/List/index": [
		223,
		9
	],
	"./Access/School/List/index.js": [
		223,
		9
	],
	"./Access/Users/Create": [
		224,
		9
	],
	"./Access/Users/Create/": [
		224,
		9
	],
	"./Access/Users/Create/Create-documentation.md": [
		897,
		9
	],
	"./Access/Users/Create/index": [
		224,
		9
	],
	"./Access/Users/Create/index.js": [
		224,
		9
	],
	"./Access/Users/List": [
		400,
		9
	],
	"./Access/Users/List/": [
		400,
		9
	],
	"./Access/Users/List/List-documentation.md": [
		898,
		9
	],
	"./Access/Users/List/index": [
		400,
		9
	],
	"./Access/Users/List/index.js": [
		400,
		9
	],
	"./Access/Users/users.css": [
		687,
		7
	],
	"./Activity/Activity/ActivityActivity-documentation.md": [
		899,
		9
	],
	"./Activity/Activity/Allocate": [
		401,
		9
	],
	"./Activity/Activity/Allocate/": [
		401,
		9
	],
	"./Activity/Activity/Allocate/Allocate-documentation.md": [
		900,
		9
	],
	"./Activity/Activity/Allocate/index": [
		401,
		9
	],
	"./Activity/Activity/Allocate/index.js": [
		401,
		9
	],
	"./Activity/Activity/Allocate/style.css": [
		688,
		7
	],
	"./Activity/Activity/Bank": [
		402,
		9
	],
	"./Activity/Activity/Bank/": [
		402,
		9
	],
	"./Activity/Activity/Bank/Bank-documentation.md": [
		901,
		9
	],
	"./Activity/Activity/Bank/index": [
		402,
		9
	],
	"./Activity/Activity/Bank/index.jsx": [
		402,
		9
	],
	"./Activity/Activity/Correct": [
		225,
		9
	],
	"./Activity/Activity/Correct/": [
		225,
		9
	],
	"./Activity/Activity/Correct/Correct-documentation.md": [
		909,
		9
	],
	"./Activity/Activity/Correct/index": [
		225,
		9
	],
	"./Activity/Activity/Correct/index.js": [
		225,
		9
	],
	"./Activity/Activity/Correct/style.css": [
		910,
		7
	],
	"./Activity/Activity/Create": [
		226,
		9
	],
	"./Activity/Activity/Create/": [
		226,
		9
	],
	"./Activity/Activity/Create/Create-documentation.md": [
		924,
		9
	],
	"./Activity/Activity/Create/index": [
		226,
		9
	],
	"./Activity/Activity/Create/index.js": [
		226,
		9
	],
	"./Activity/Activity/Do": [
		228,
		9
	],
	"./Activity/Activity/Do/": [
		228,
		9
	],
	"./Activity/Activity/Do/Do-documentation.md": [
		925,
		9
	],
	"./Activity/Activity/Do/activityItemStatistics": [
		577,
		9
	],
	"./Activity/Activity/Do/activityItemStatistics.jsx": [
		577,
		9
	],
	"./Activity/Activity/Do/evaluationStatistics": [
		449,
		9
	],
	"./Activity/Activity/Do/evaluationStatistics.jsx": [
		449,
		9
	],
	"./Activity/Activity/Do/index": [
		228,
		9
	],
	"./Activity/Activity/Do/index.jsx": [
		228,
		9
	],
	"./Activity/Activity/Do/style.css": [
		530,
		7
	],
	"./Activity/Activity/List": [
		403,
		9
	],
	"./Activity/Activity/List/": [
		403,
		9
	],
	"./Activity/Activity/List/List-documentation.md": [
		926,
		9
	],
	"./Activity/Activity/List/index": [
		403,
		9
	],
	"./Activity/Activity/List/index.js": [
		403,
		9
	],
	"./Activity/Activity/Live": [
		395,
		9
	],
	"./Activity/Activity/Live/": [
		395,
		9
	],
	"./Activity/Activity/Live/Live-documentation.md": [
		975,
		9
	],
	"./Activity/Activity/Live/index": [
		395,
		9
	],
	"./Activity/Activity/Live/index.jsx": [
		395,
		9
	],
	"./Activity/Activity/Live/style.scss": [
		700,
		7
	],
	"./Activity/Activity/Me": [
		230,
		9
	],
	"./Activity/Activity/Me/": [
		230,
		9
	],
	"./Activity/Activity/Me/Me-documentation.md": [
		976,
		9
	],
	"./Activity/Activity/Me/index": [
		230,
		9
	],
	"./Activity/Activity/Me/index.js": [
		230,
		9
	],
	"./Activity/Activity/Me/style.css": [
		721,
		7
	],
	"./Activity/Activity/Show": [
		231,
		9
	],
	"./Activity/Activity/Show/": [
		231,
		9
	],
	"./Activity/Activity/Show/index": [
		231,
		9
	],
	"./Activity/Activity/Show/index.js": [
		231,
		9
	],
	"./Activity/Activity/TV/Report": [
		232,
		9
	],
	"./Activity/Activity/TV/Report/": [
		232,
		9
	],
	"./Activity/Activity/TV/Report/TVReport-documentation.md": [
		977,
		9
	],
	"./Activity/Activity/TV/Report/index": [
		232,
		9
	],
	"./Activity/Activity/TV/Report/index.jsx": [
		232,
		9
	],
	"./Activity/Activity/TV/Share": [
		233,
		9
	],
	"./Activity/Activity/TV/Share/": [
		233,
		9
	],
	"./Activity/Activity/TV/Share/index": [
		233,
		9
	],
	"./Activity/Activity/TV/Share/index.jsx": [
		233,
		9
	],
	"./Activity/Activity/View": [
		234,
		9
	],
	"./Activity/Activity/View/": [
		234,
		9
	],
	"./Activity/Activity/View/View-documentation.md": [
		978,
		9
	],
	"./Activity/Activity/View/index": [
		234,
		9
	],
	"./Activity/Activity/View/index.js": [
		234,
		9
	],
	"./Activity/Literarte": [
		235,
		9
	],
	"./Activity/Literarte/": [
		235,
		9
	],
	"./Activity/Literarte/Literarte-documentation.md": [
		979,
		9
	],
	"./Activity/Literarte/index": [
		235,
		9
	],
	"./Activity/Literarte/index.jsx": [
		235,
		9
	],
	"./Activity/Literarte/styles.css": [
		722,
		7
	],
	"./Activity/Trail/Activity": [
		236,
		9
	],
	"./Activity/Trail/Activity/": [
		236,
		9
	],
	"./Activity/Trail/Activity/Activity-documentation.md": [
		980,
		9
	],
	"./Activity/Trail/Activity/activityItemStatistics": [
		583,
		9
	],
	"./Activity/Trail/Activity/activityItemStatistics.jsx": [
		583,
		9
	],
	"./Activity/Trail/Activity/evaluationStatistics": [
		421,
		9
	],
	"./Activity/Trail/Activity/evaluationStatistics.jsx": [
		421,
		9
	],
	"./Activity/Trail/Activity/index": [
		236,
		9
	],
	"./Activity/Trail/Activity/index.jsx": [
		236,
		9
	],
	"./Activity/Trail/Activity/statistics": [
		420,
		9
	],
	"./Activity/Trail/Activity/statistics.jsx": [
		420,
		9
	],
	"./Activity/Trail/Activity/style.css": [
		536,
		7
	],
	"./Activity/Trail/Allocate": [
		237,
		9
	],
	"./Activity/Trail/Allocate/": [
		237,
		9
	],
	"./Activity/Trail/Allocate/Allocate-documentation.md": [
		981,
		9
	],
	"./Activity/Trail/Allocate/index": [
		237,
		9
	],
	"./Activity/Trail/Allocate/index.js": [
		237,
		9
	],
	"./Activity/Trail/Allocate/style.css": [
		723,
		7
	],
	"./Activity/Trail/Bank": [
		238,
		9
	],
	"./Activity/Trail/Bank/": [
		238,
		9
	],
	"./Activity/Trail/Bank/Bank-documentation.md": [
		982,
		9
	],
	"./Activity/Trail/Bank/index": [
		238,
		9
	],
	"./Activity/Trail/Bank/index.jsx": [
		238,
		9
	],
	"./Activity/Trail/Correct": [
		239,
		9
	],
	"./Activity/Trail/Correct/": [
		239,
		9
	],
	"./Activity/Trail/Correct/Correct-documentation.md": [
		983,
		9
	],
	"./Activity/Trail/Correct/index": [
		239,
		9
	],
	"./Activity/Trail/Correct/index.js": [
		239,
		9
	],
	"./Activity/Trail/Correct/style.css": [
		984,
		7
	],
	"./Activity/Trail/Do": [
		391,
		9
	],
	"./Activity/Trail/Do/": [
		391,
		9
	],
	"./Activity/Trail/Do/Do-documentation.md": [
		986,
		9
	],
	"./Activity/Trail/Do/index": [
		391,
		9
	],
	"./Activity/Trail/Do/index.jsx": [
		391,
		9
	],
	"./Activity/Trail/Do/style.css": [
		724,
		7
	],
	"./Activity/Trail/Edit": [
		240,
		9
	],
	"./Activity/Trail/Edit/": [
		240,
		9
	],
	"./Activity/Trail/Edit/index": [
		240,
		9
	],
	"./Activity/Trail/Edit/index.jsx": [
		240,
		9
	],
	"./Activity/Trail/Edit/style.css": [
		725,
		7
	],
	"./Activity/Trail/Grade/Send": [
		241,
		9
	],
	"./Activity/Trail/Grade/Send/": [
		241,
		9
	],
	"./Activity/Trail/Grade/Send/index": [
		241,
		9
	],
	"./Activity/Trail/Grade/Send/index.jsx": [
		241,
		9
	],
	"./Activity/Trail/Grade/Send/styles.css": [
		726,
		7
	],
	"./Activity/Trail/Grade/Show": [
		242,
		9
	],
	"./Activity/Trail/Grade/Show/": [
		242,
		9
	],
	"./Activity/Trail/Grade/Show/index": [
		242,
		9
	],
	"./Activity/Trail/Grade/Show/index.jsx": [
		242,
		9
	],
	"./Activity/Trail/List": [
		404,
		9
	],
	"./Activity/Trail/List/": [
		404,
		9
	],
	"./Activity/Trail/List/List-documentation.md": [
		987,
		9
	],
	"./Activity/Trail/List/index": [
		404,
		9
	],
	"./Activity/Trail/List/index.jsx": [
		404,
		9
	],
	"./Activity/Trail/PartialProgression/AllocateByTrail": [
		243,
		9
	],
	"./Activity/Trail/PartialProgression/AllocateByTrail/": [
		243,
		9
	],
	"./Activity/Trail/PartialProgression/AllocateByTrail/index": [
		243,
		9
	],
	"./Activity/Trail/PartialProgression/AllocateByTrail/index.jsx": [
		243,
		9
	],
	"./Activity/Trail/PartialProgression/AllocateByUser": [
		244,
		9
	],
	"./Activity/Trail/PartialProgression/AllocateByUser/": [
		244,
		9
	],
	"./Activity/Trail/PartialProgression/AllocateByUser/index": [
		244,
		9
	],
	"./Activity/Trail/PartialProgression/AllocateByUser/index.jsx": [
		244,
		9
	],
	"./Activity/Trail/PartialProgression/Bank": [
		245,
		9
	],
	"./Activity/Trail/PartialProgression/Bank/": [
		245,
		9
	],
	"./Activity/Trail/PartialProgression/Bank/index": [
		245,
		9
	],
	"./Activity/Trail/PartialProgression/Bank/index.jsx": [
		245,
		9
	],
	"./Activity/Trail/PartialProgression/Grade/Send": [
		246,
		9
	],
	"./Activity/Trail/PartialProgression/Grade/Send/": [
		246,
		9
	],
	"./Activity/Trail/PartialProgression/Grade/Send/index": [
		246,
		9
	],
	"./Activity/Trail/PartialProgression/Grade/Send/index.jsx": [
		246,
		9
	],
	"./Activity/Trail/PartialProgression/Grade/Show": [
		247,
		9
	],
	"./Activity/Trail/PartialProgression/Grade/Show/": [
		247,
		9
	],
	"./Activity/Trail/PartialProgression/Grade/Show/index": [
		247,
		9
	],
	"./Activity/Trail/PartialProgression/Grade/Show/index.jsx": [
		247,
		9
	],
	"./Activity/Trail/PartialProgression/Statistics": [
		248,
		9
	],
	"./Activity/Trail/PartialProgression/Statistics/": [
		248,
		9
	],
	"./Activity/Trail/PartialProgression/Statistics/index": [
		248,
		9
	],
	"./Activity/Trail/PartialProgression/Statistics/index.jsx": [
		248,
		9
	],
	"./Activity/Trail/Show": [
		249,
		9
	],
	"./Activity/Trail/Show/": [
		249,
		9
	],
	"./Activity/Trail/Show/Show-documentation.md": [
		988,
		9
	],
	"./Activity/Trail/Show/index": [
		249,
		9
	],
	"./Activity/Trail/Show/index.jsx": [
		249,
		9
	],
	"./Activity/Trail/Show/style.css": [
		727,
		7
	],
	"./AllocationFinder": [
		185,
		9
	],
	"./AllocationFinder/": [
		185,
		9
	],
	"./AllocationFinder/AllocationFinder-documentation.md": [
		989,
		9
	],
	"./AllocationFinder/index": [
		185,
		9
	],
	"./AllocationFinder/index.js": [
		185,
		9
	],
	"./AllocationFinder/style.css": [
		666,
		7
	],
	"./Audict/Action/Create": [
		250,
		9
	],
	"./Audict/Action/Create/": [
		250,
		9
	],
	"./Audict/Action/Create/Create-documentation.md": [
		990,
		9
	],
	"./Audict/Action/Create/index": [
		250,
		9
	],
	"./Audict/Action/Create/index.js": [
		250,
		9
	],
	"./Audict/Action/List": [
		251,
		9
	],
	"./Audict/Action/List/": [
		251,
		9
	],
	"./Audict/Action/List/List-documentation.md": [
		991,
		9
	],
	"./Audict/Action/List/index": [
		251,
		9
	],
	"./Audict/Action/List/index.js": [
		251,
		9
	],
	"./Audict/Origin/Create": [
		252,
		9
	],
	"./Audict/Origin/Create/": [
		252,
		9
	],
	"./Audict/Origin/Create/Create-documentation.md": [
		992,
		9
	],
	"./Audict/Origin/Create/index": [
		252,
		9
	],
	"./Audict/Origin/Create/index.js": [
		252,
		9
	],
	"./Audict/Origin/List": [
		253,
		9
	],
	"./Audict/Origin/List/": [
		253,
		9
	],
	"./Audict/Origin/List/List-documentation.md": [
		993,
		9
	],
	"./Audict/Origin/List/index": [
		253,
		9
	],
	"./Audict/Origin/List/index.js": [
		253,
		9
	],
	"./Banner": [
		254,
		9
	],
	"./Banner/": [
		254,
		9
	],
	"./Banner/index": [
		254,
		9
	],
	"./Banner/index.js": [
		254,
		9
	],
	"./Child": [
		255,
		9
	],
	"./Child/": [
		255,
		9
	],
	"./Child/Child-documentation.md": [
		994,
		9
	],
	"./Child/index": [
		255,
		9
	],
	"./Child/index.jsx": [
		255,
		9
	],
	"./Classification/Ability/Create": [
		256,
		9
	],
	"./Classification/Ability/Create/": [
		256,
		9
	],
	"./Classification/Ability/Create/Create-documentation.md": [
		995,
		9
	],
	"./Classification/Ability/Create/index": [
		256,
		9
	],
	"./Classification/Ability/Create/index.js": [
		256,
		9
	],
	"./Classification/Ability/List": [
		257,
		9
	],
	"./Classification/Ability/List/": [
		257,
		9
	],
	"./Classification/Ability/List/List-documentation.md": [
		996,
		9
	],
	"./Classification/Ability/List/index": [
		257,
		9
	],
	"./Classification/Ability/List/index.js": [
		257,
		9
	],
	"./Classification/DifficultyLevel/Create": [
		258,
		9
	],
	"./Classification/DifficultyLevel/Create/": [
		258,
		9
	],
	"./Classification/DifficultyLevel/Create/Create-documentation.md": [
		997,
		9
	],
	"./Classification/DifficultyLevel/Create/index": [
		258,
		9
	],
	"./Classification/DifficultyLevel/Create/index.js": [
		258,
		9
	],
	"./Classification/DifficultyLevel/List": [
		259,
		9
	],
	"./Classification/DifficultyLevel/List/": [
		259,
		9
	],
	"./Classification/DifficultyLevel/List/List-documentation.md": [
		998,
		9
	],
	"./Classification/DifficultyLevel/List/index": [
		259,
		9
	],
	"./Classification/DifficultyLevel/List/index.js": [
		259,
		9
	],
	"./Classification/Discipline/Create": [
		260,
		9
	],
	"./Classification/Discipline/Create/": [
		260,
		9
	],
	"./Classification/Discipline/Create/Create-documentation.md": [
		999,
		9
	],
	"./Classification/Discipline/Create/index": [
		260,
		9
	],
	"./Classification/Discipline/Create/index.js": [
		260,
		9
	],
	"./Classification/Discipline/List": [
		261,
		9
	],
	"./Classification/Discipline/List/": [
		261,
		9
	],
	"./Classification/Discipline/List/List-documentation.md": [
		1000,
		9
	],
	"./Classification/Discipline/List/index": [
		261,
		9
	],
	"./Classification/Discipline/List/index.js": [
		261,
		9
	],
	"./Classification/Goal/Create": [
		262,
		9
	],
	"./Classification/Goal/Create/": [
		262,
		9
	],
	"./Classification/Goal/Create/Create-documentation.md": [
		1001,
		9
	],
	"./Classification/Goal/Create/index": [
		262,
		9
	],
	"./Classification/Goal/Create/index.js": [
		262,
		9
	],
	"./Classification/Goal/List": [
		263,
		9
	],
	"./Classification/Goal/List/": [
		263,
		9
	],
	"./Classification/Goal/List/List-documentation.md": [
		1002,
		9
	],
	"./Classification/Goal/List/index": [
		263,
		9
	],
	"./Classification/Goal/List/index.js": [
		263,
		9
	],
	"./Classification/Grade/Create": [
		264,
		9
	],
	"./Classification/Grade/Create/": [
		264,
		9
	],
	"./Classification/Grade/Create/Create-documentation.md": [
		1003,
		9
	],
	"./Classification/Grade/Create/index": [
		264,
		9
	],
	"./Classification/Grade/Create/index.js": [
		264,
		9
	],
	"./Classification/Grade/List": [
		265,
		9
	],
	"./Classification/Grade/List/": [
		265,
		9
	],
	"./Classification/Grade/List/List-documentation.md": [
		1004,
		9
	],
	"./Classification/Grade/List/index": [
		265,
		9
	],
	"./Classification/Grade/List/index.js": [
		265,
		9
	],
	"./Classification/LearningArea/Create": [
		266,
		9
	],
	"./Classification/LearningArea/Create/": [
		266,
		9
	],
	"./Classification/LearningArea/Create/Create-documentation.md": [
		1005,
		9
	],
	"./Classification/LearningArea/Create/index": [
		266,
		9
	],
	"./Classification/LearningArea/Create/index.js": [
		266,
		9
	],
	"./Classification/LearningArea/List": [
		267,
		9
	],
	"./Classification/LearningArea/List/": [
		267,
		9
	],
	"./Classification/LearningArea/List/List-documentation.md": [
		1006,
		9
	],
	"./Classification/LearningArea/List/index": [
		267,
		9
	],
	"./Classification/LearningArea/List/index.js": [
		267,
		9
	],
	"./Classification/Module/Create": [
		268,
		9
	],
	"./Classification/Module/Create/": [
		268,
		9
	],
	"./Classification/Module/Create/Create-documentation.md": [
		1007,
		9
	],
	"./Classification/Module/Create/index": [
		268,
		9
	],
	"./Classification/Module/Create/index.js": [
		268,
		9
	],
	"./Classification/Module/List": [
		269,
		9
	],
	"./Classification/Module/List/": [
		269,
		9
	],
	"./Classification/Module/List/List-documentation.md": [
		1008,
		9
	],
	"./Classification/Module/List/index": [
		269,
		9
	],
	"./Classification/Module/List/index.js": [
		269,
		9
	],
	"./Classification/Segment/Create": [
		270,
		9
	],
	"./Classification/Segment/Create/": [
		270,
		9
	],
	"./Classification/Segment/Create/Create-documentation.md": [
		1009,
		9
	],
	"./Classification/Segment/Create/index": [
		270,
		9
	],
	"./Classification/Segment/Create/index.js": [
		270,
		9
	],
	"./Classification/Segment/List": [
		271,
		9
	],
	"./Classification/Segment/List/": [
		271,
		9
	],
	"./Classification/Segment/List/List-documentation.md": [
		1010,
		9
	],
	"./Classification/Segment/List/index": [
		271,
		9
	],
	"./Classification/Segment/List/index.js": [
		271,
		9
	],
	"./Classification/Source/Create": [
		272,
		9
	],
	"./Classification/Source/Create/": [
		272,
		9
	],
	"./Classification/Source/Create/Create-documentation.md": [
		1011,
		9
	],
	"./Classification/Source/Create/index": [
		272,
		9
	],
	"./Classification/Source/Create/index.js": [
		272,
		9
	],
	"./Classification/Source/List": [
		273,
		9
	],
	"./Classification/Source/List/": [
		273,
		9
	],
	"./Classification/Source/List/List-documentation.md": [
		1012,
		9
	],
	"./Classification/Source/List/index": [
		273,
		9
	],
	"./Classification/Source/List/index.js": [
		273,
		9
	],
	"./Classification/ThematicUnit/Create": [
		274,
		9
	],
	"./Classification/ThematicUnit/Create/": [
		274,
		9
	],
	"./Classification/ThematicUnit/Create/Create-documentation.md": [
		1013,
		9
	],
	"./Classification/ThematicUnit/Create/index": [
		274,
		9
	],
	"./Classification/ThematicUnit/Create/index.js": [
		274,
		9
	],
	"./Classification/ThematicUnit/List": [
		275,
		9
	],
	"./Classification/ThematicUnit/List/": [
		275,
		9
	],
	"./Classification/ThematicUnit/List/List-documentation.md": [
		1014,
		9
	],
	"./Classification/ThematicUnit/List/index": [
		275,
		9
	],
	"./Classification/ThematicUnit/List/index.js": [
		275,
		9
	],
	"./Communication/Notification/Create": [
		276,
		9
	],
	"./Communication/Notification/Create/": [
		276,
		9
	],
	"./Communication/Notification/Create/Create-documentation.md": [
		1015,
		9
	],
	"./Communication/Notification/Create/index": [
		276,
		9
	],
	"./Communication/Notification/Create/index.js": [
		276,
		9
	],
	"./Communication/Notification/Create/style.css": [
		728,
		7
	],
	"./Communication/Notification/Detail": [
		277,
		9
	],
	"./Communication/Notification/Detail/": [
		277,
		9
	],
	"./Communication/Notification/Detail/Detail-documentation.md": [
		1016,
		9
	],
	"./Communication/Notification/Detail/index": [
		277,
		9
	],
	"./Communication/Notification/Detail/index.js": [
		277,
		9
	],
	"./Communication/Notification/Detail/style.css": [
		729,
		7
	],
	"./Communication/Notification/List": [
		278,
		9
	],
	"./Communication/Notification/List/": [
		278,
		9
	],
	"./Communication/Notification/List/List-documentation.md": [
		1017,
		9
	],
	"./Communication/Notification/List/index": [
		278,
		9
	],
	"./Communication/Notification/List/index.js": [
		278,
		9
	],
	"./Communication/Notification/Me": [
		279,
		9
	],
	"./Communication/Notification/Me/": [
		279,
		9
	],
	"./Communication/Notification/Me/Me-documentation.md": [
		1018,
		9
	],
	"./Communication/Notification/Me/index": [
		279,
		9
	],
	"./Communication/Notification/Me/index.js": [
		279,
		9
	],
	"./Communication/Notification/Me/style.css": [
		730,
		7
	],
	"./Communication/Occurrence/Create": [
		280,
		9
	],
	"./Communication/Occurrence/Create/": [
		280,
		9
	],
	"./Communication/Occurrence/Create/Create-documentation.md": [
		1019,
		9
	],
	"./Communication/Occurrence/Create/index": [
		280,
		9
	],
	"./Communication/Occurrence/Create/index.js": [
		280,
		9
	],
	"./Communication/Occurrence/Detail": [
		281,
		9
	],
	"./Communication/Occurrence/Detail/": [
		281,
		9
	],
	"./Communication/Occurrence/Detail/Detail-documentation.md": [
		1020,
		9
	],
	"./Communication/Occurrence/Detail/index": [
		281,
		9
	],
	"./Communication/Occurrence/Detail/index.js": [
		281,
		9
	],
	"./Communication/Occurrence/Detail/style.css": [
		731,
		7
	],
	"./Communication/Occurrence/List": [
		282,
		9
	],
	"./Communication/Occurrence/List/": [
		282,
		9
	],
	"./Communication/Occurrence/List/List-documentation.md": [
		1021,
		9
	],
	"./Communication/Occurrence/List/index": [
		282,
		9
	],
	"./Communication/Occurrence/List/index.js": [
		282,
		9
	],
	"./Communication/Occurrence/Me": [
		283,
		9
	],
	"./Communication/Occurrence/Me/": [
		283,
		9
	],
	"./Communication/Occurrence/Me/Me-documentation.md": [
		1022,
		9
	],
	"./Communication/Occurrence/Me/index": [
		283,
		9
	],
	"./Communication/Occurrence/Me/index.js": [
		283,
		9
	],
	"./Communication/Occurrence/Me/style.css": [
		732,
		7
	],
	"./Communication/OccurrenceType/Create": [
		284,
		9
	],
	"./Communication/OccurrenceType/Create/": [
		284,
		9
	],
	"./Communication/OccurrenceType/Create/Create-documentation.md": [
		1023,
		9
	],
	"./Communication/OccurrenceType/Create/index": [
		284,
		9
	],
	"./Communication/OccurrenceType/Create/index.js": [
		284,
		9
	],
	"./Communication/OccurrenceType/List": [
		285,
		9
	],
	"./Communication/OccurrenceType/List/": [
		285,
		9
	],
	"./Communication/OccurrenceType/List/List-documentation.md": [
		1024,
		9
	],
	"./Communication/OccurrenceType/List/index": [
		285,
		9
	],
	"./Communication/OccurrenceType/List/index.js": [
		285,
		9
	],
	"./Community/Classroom/Create": [
		286,
		9
	],
	"./Community/Classroom/Create/": [
		286,
		9
	],
	"./Community/Classroom/Create/Create-documentation.md": [
		1025,
		9
	],
	"./Community/Classroom/Create/index": [
		286,
		9
	],
	"./Community/Classroom/Create/index.js": [
		286,
		9
	],
	"./Community/Classroom/Create/styles.css": [
		733,
		7
	],
	"./Community/Classroom/Jitsi": [
		287,
		9
	],
	"./Community/Classroom/Jitsi/": [
		287,
		9
	],
	"./Community/Classroom/Jitsi/Jitsi-documentation.md": [
		1026,
		9
	],
	"./Community/Classroom/Jitsi/index": [
		287,
		9
	],
	"./Community/Classroom/Jitsi/index.js": [
		287,
		9
	],
	"./Community/Classroom/Jitsi/styles.css": [
		734,
		7
	],
	"./Community/Classroom/List": [
		288,
		9
	],
	"./Community/Classroom/List/": [
		288,
		9
	],
	"./Community/Classroom/List/List-documentation.md": [
		1027,
		9
	],
	"./Community/Classroom/List/index": [
		288,
		9
	],
	"./Community/Classroom/List/index.js": [
		288,
		9
	],
	"./Community/Classroom/Me": [
		289,
		9
	],
	"./Community/Classroom/Me/": [
		289,
		9
	],
	"./Community/Classroom/Me/Me-documentation.md": [
		1028,
		9
	],
	"./Community/Classroom/Me/index": [
		289,
		9
	],
	"./Community/Classroom/Me/index.js": [
		289,
		9
	],
	"./Community/Classroom/Me/styles.css": [
		735,
		7
	],
	"./Community/Classroom/Members": [
		396,
		9
	],
	"./Community/Classroom/Members/": [
		396,
		9
	],
	"./Community/Classroom/Members/Members-documentation.md": [
		1029,
		9
	],
	"./Community/Classroom/Members/index": [
		396,
		9
	],
	"./Community/Classroom/Members/index.js": [
		396,
		9
	],
	"./Community/Classroom/Members/styles.css": [
		736,
		7
	],
	"./Community/Classroom/Migrate": [
		290,
		9
	],
	"./Community/Classroom/Migrate/": [
		290,
		9
	],
	"./Community/Classroom/Migrate/Migrate-documentation.md": [
		1030,
		9
	],
	"./Community/Classroom/Migrate/index": [
		290,
		9
	],
	"./Community/Classroom/Migrate/index.jsx": [
		290,
		9
	],
	"./Community/Classroom/Show": [
		291,
		9
	],
	"./Community/Classroom/Show/": [
		291,
		9
	],
	"./Community/Classroom/Show/Show-documentation.md": [
		1032,
		9
	],
	"./Community/Classroom/Show/index": [
		291,
		9
	],
	"./Community/Classroom/Show/index.js": [
		291,
		9
	],
	"./Community/Classroom/Show/jitsi": [
		471,
		9
	],
	"./Community/Classroom/Show/jitsi.js": [
		471,
		9
	],
	"./Community/Classroom/Show/statistics": [
		192,
		9
	],
	"./Community/Classroom/Show/statistics.jsx": [
		192,
		9
	],
	"./Community/Classroom/Show/styles.css": [
		537,
		7
	],
	"./Community/Room/Create": [
		292,
		9
	],
	"./Community/Room/Create/": [
		292,
		9
	],
	"./Community/Room/Create/Create-documentation.md": [
		1033,
		9
	],
	"./Community/Room/Create/index": [
		292,
		9
	],
	"./Community/Room/Create/index.js": [
		292,
		9
	],
	"./Community/Room/Create/users": [
		584,
		9
	],
	"./Community/Room/Create/users.js": [
		584,
		9
	],
	"./Community/Room/List": [
		293,
		9
	],
	"./Community/Room/List/": [
		293,
		9
	],
	"./Community/Room/List/List-documentation.md": [
		1034,
		9
	],
	"./Community/Room/List/index": [
		293,
		9
	],
	"./Community/Room/List/index.js": [
		293,
		9
	],
	"./Community/Room/Me": [
		294,
		9
	],
	"./Community/Room/Me/": [
		294,
		9
	],
	"./Community/Room/Me/Me-documentation.md": [
		1035,
		9
	],
	"./Community/Room/Me/index": [
		294,
		9
	],
	"./Community/Room/Me/index.js": [
		294,
		9
	],
	"./Community/Room/Me/search": [
		472,
		9
	],
	"./Community/Room/Me/search.js": [
		472,
		9
	],
	"./Community/Room/Me/styles.css": [
		737,
		7
	],
	"./Community/Room/Members": [
		295,
		9
	],
	"./Community/Room/Members/": [
		295,
		9
	],
	"./Community/Room/Members/Members-documentation.md": [
		1036,
		9
	],
	"./Community/Room/Members/index": [
		295,
		9
	],
	"./Community/Room/Members/index.js": [
		295,
		9
	],
	"./Community/Room/Show": [
		296,
		9
	],
	"./Community/Room/Show/": [
		296,
		9
	],
	"./Community/Room/Show/Show-documentation.md": [
		1037,
		9
	],
	"./Community/Room/Show/index": [
		296,
		9
	],
	"./Community/Room/Show/index.js": [
		296,
		9
	],
	"./Community/Room/Show/styles.css": [
		738,
		7
	],
	"./Configuration/ADR/CreateOrigin": [
		297,
		9
	],
	"./Configuration/ADR/CreateOrigin/": [
		297,
		9
	],
	"./Configuration/ADR/CreateOrigin/index": [
		297,
		9
	],
	"./Configuration/ADR/CreateOrigin/index.jsx": [
		297,
		9
	],
	"./Configuration/ADR/Origin": [
		298,
		9
	],
	"./Configuration/ADR/Origin/": [
		298,
		9
	],
	"./Configuration/ADR/Origin/index": [
		298,
		9
	],
	"./Configuration/ADR/Origin/index.jsx": [
		298,
		9
	],
	"./Configuration/Component/Create": [
		299,
		9
	],
	"./Configuration/Component/Create/": [
		299,
		9
	],
	"./Configuration/Component/Create/Create-documentation.md": [
		1038,
		9
	],
	"./Configuration/Component/Create/index": [
		299,
		9
	],
	"./Configuration/Component/Create/index.js": [
		299,
		9
	],
	"./Configuration/Component/List": [
		300,
		9
	],
	"./Configuration/Component/List/": [
		300,
		9
	],
	"./Configuration/Component/List/List-documentation.md": [
		1039,
		9
	],
	"./Configuration/Component/List/index": [
		300,
		9
	],
	"./Configuration/Component/List/index.js": [
		300,
		9
	],
	"./Configuration/Language/Create": [
		301,
		9
	],
	"./Configuration/Language/Create/": [
		301,
		9
	],
	"./Configuration/Language/Create/Create-documentation.md": [
		1040,
		9
	],
	"./Configuration/Language/Create/index": [
		301,
		9
	],
	"./Configuration/Language/Create/index.js": [
		301,
		9
	],
	"./Configuration/Language/List": [
		302,
		9
	],
	"./Configuration/Language/List/": [
		302,
		9
	],
	"./Configuration/Language/List/List-documentation.md": [
		1041,
		9
	],
	"./Configuration/Language/List/index": [
		302,
		9
	],
	"./Configuration/Language/List/index.js": [
		302,
		9
	],
	"./Configuration/Menu/List": [
		405,
		9
	],
	"./Configuration/Menu/List/": [
		405,
		9
	],
	"./Configuration/Menu/List/List-documentation.md": [
		1042,
		9
	],
	"./Configuration/Menu/List/index": [
		405,
		9
	],
	"./Configuration/Menu/List/index.js": [
		405,
		9
	],
	"./Configuration/Menu/List/styles.css": [
		739,
		7
	],
	"./Configuration/Module/Create": [
		303,
		9
	],
	"./Configuration/Module/Create/": [
		303,
		9
	],
	"./Configuration/Module/Create/Create-documentation.md": [
		1043,
		9
	],
	"./Configuration/Module/Create/index": [
		303,
		9
	],
	"./Configuration/Module/Create/index.js": [
		303,
		9
	],
	"./Configuration/Module/List": [
		304,
		9
	],
	"./Configuration/Module/List/": [
		304,
		9
	],
	"./Configuration/Module/List/List-documentation.md": [
		1044,
		9
	],
	"./Configuration/Module/List/index": [
		304,
		9
	],
	"./Configuration/Module/List/index.js": [
		304,
		9
	],
	"./Configuration/Role/Create": [
		305,
		9
	],
	"./Configuration/Role/Create/": [
		305,
		9
	],
	"./Configuration/Role/Create/Create-documentation.md": [
		1045,
		9
	],
	"./Configuration/Role/Create/index": [
		305,
		9
	],
	"./Configuration/Role/Create/index.js": [
		305,
		9
	],
	"./Configuration/Role/Create/styles.css": [
		740,
		7
	],
	"./Configuration/Role/List": [
		306,
		9
	],
	"./Configuration/Role/List/": [
		306,
		9
	],
	"./Configuration/Role/List/List-documentation.md": [
		1046,
		9
	],
	"./Configuration/Role/List/index": [
		306,
		9
	],
	"./Configuration/Role/List/index.js": [
		306,
		9
	],
	"./Configuration/SocialNetwork/Create": [
		307,
		9
	],
	"./Configuration/SocialNetwork/Create/": [
		307,
		9
	],
	"./Configuration/SocialNetwork/Create/Create-documentation.md": [
		1047,
		9
	],
	"./Configuration/SocialNetwork/Create/index": [
		307,
		9
	],
	"./Configuration/SocialNetwork/Create/index.js": [
		307,
		9
	],
	"./Configuration/SocialNetwork/List": [
		308,
		9
	],
	"./Configuration/SocialNetwork/List/": [
		308,
		9
	],
	"./Configuration/SocialNetwork/List/List-documentation.md": [
		1048,
		9
	],
	"./Configuration/SocialNetwork/List/index": [
		308,
		9
	],
	"./Configuration/SocialNetwork/List/index.js": [
		308,
		9
	],
	"./Configuration/Translation/Create": [
		309,
		9
	],
	"./Configuration/Translation/Create/": [
		309,
		9
	],
	"./Configuration/Translation/Create/Create-documentation.md": [
		1049,
		9
	],
	"./Configuration/Translation/Create/index": [
		309,
		9
	],
	"./Configuration/Translation/Create/index.js": [
		309,
		9
	],
	"./Configuration/Translation/List": [
		310,
		9
	],
	"./Configuration/Translation/List/": [
		310,
		9
	],
	"./Configuration/Translation/List/List-documentation.md": [
		1050,
		9
	],
	"./Configuration/Translation/List/index": [
		310,
		9
	],
	"./Configuration/Translation/List/index.js": [
		310,
		9
	],
	"./Consolidated/Panel": [
		311,
		9
	],
	"./Consolidated/Panel/": [
		311,
		9
	],
	"./Consolidated/Panel/Panel-documentation.md": [
		1051,
		9
	],
	"./Consolidated/Panel/filter": [
		473,
		9
	],
	"./Consolidated/Panel/filter.jsx": [
		473,
		9
	],
	"./Consolidated/Panel/index": [
		311,
		9
	],
	"./Consolidated/Panel/index.jsx": [
		311,
		9
	],
	"./Content/Docs/Me": [
		312,
		9
	],
	"./Content/Docs/Me/": [
		312,
		9
	],
	"./Content/Docs/Me/Me-documentation.md": [
		1052,
		9
	],
	"./Content/Docs/Me/edit": [
		475,
		9
	],
	"./Content/Docs/Me/edit.js": [
		475,
		9
	],
	"./Content/Docs/Me/folder": [
		477,
		9
	],
	"./Content/Docs/Me/folder.js": [
		477,
		9
	],
	"./Content/Docs/Me/index": [
		312,
		9
	],
	"./Content/Docs/Me/index.js": [
		312,
		9
	],
	"./Content/Docs/Me/info": [
		478,
		9
	],
	"./Content/Docs/Me/info.js": [
		478,
		9
	],
	"./Content/Docs/Me/permission": [
		474,
		9
	],
	"./Content/Docs/Me/permission.js": [
		474,
		9
	],
	"./Content/Docs/Me/style.css": [
		741,
		7
	],
	"./Content/Docs/Me/upload": [
		476,
		9
	],
	"./Content/Docs/Me/upload.js": [
		476,
		9
	],
	"./Content/HandsOn": [
		313,
		9
	],
	"./Content/HandsOn/": [
		313,
		9
	],
	"./Content/HandsOn/default.png": [
		593,
		9
	],
	"./Content/HandsOn/favorites.webp": [
		594,
		9
	],
	"./Content/HandsOn/handson.webp": [
		1053,
		9
	],
	"./Content/HandsOn/index": [
		313,
		9
	],
	"./Content/HandsOn/index.jsx": [
		313,
		9
	],
	"./Content/HandsOn/roulette.webp": [
		595,
		9
	],
	"./Content/HandsOn/styles.css": [
		742,
		7
	],
	"./Content/Library": [
		314,
		9
	],
	"./Content/Library/": [
		314,
		9
	],
	"./Content/Library/Library-documentation.md": [
		1054,
		9
	],
	"./Content/Library/index": [
		314,
		9
	],
	"./Content/Library/index.jsx": [
		314,
		9
	],
	"./Content/List": [
		315,
		9
	],
	"./Content/List/": [
		315,
		9
	],
	"./Content/List/List-documentation.md": [
		1055,
		9
	],
	"./Content/List/index": [
		315,
		9
	],
	"./Content/List/index.js": [
		315,
		9
	],
	"./Content/Lo/Create": [
		316,
		9
	],
	"./Content/Lo/Create/": [
		316,
		9
	],
	"./Content/Lo/Create/Create-documentation.md": [
		1056,
		9
	],
	"./Content/Lo/Create/index": [
		316,
		9
	],
	"./Content/Lo/Create/index.js": [
		316,
		9
	],
	"./Content/Lo/List": [
		317,
		9
	],
	"./Content/Lo/List/": [
		317,
		9
	],
	"./Content/Lo/List/List-documentation.md": [
		1057,
		9
	],
	"./Content/Lo/List/index": [
		317,
		9
	],
	"./Content/Lo/List/index.js": [
		317,
		9
	],
	"./Content/Skin/Create": [
		318,
		9
	],
	"./Content/Skin/Create/": [
		318,
		9
	],
	"./Content/Skin/Create/Create-documentation.md": [
		1058,
		9
	],
	"./Content/Skin/Create/index": [
		318,
		9
	],
	"./Content/Skin/Create/index.js": [
		318,
		9
	],
	"./Content/Skin/List": [
		319,
		9
	],
	"./Content/Skin/List/": [
		319,
		9
	],
	"./Content/Skin/List/List-documentation.md": [
		1059,
		9
	],
	"./Content/Skin/List/index": [
		319,
		9
	],
	"./Content/Skin/List/index.js": [
		319,
		9
	],
	"./Content/Type/Create": [
		320,
		9
	],
	"./Content/Type/Create/": [
		320,
		9
	],
	"./Content/Type/Create/Create-documentation.md": [
		1060,
		9
	],
	"./Content/Type/Create/index": [
		320,
		9
	],
	"./Content/Type/Create/index.js": [
		320,
		9
	],
	"./Content/Type/List": [
		321,
		9
	],
	"./Content/Type/List/": [
		321,
		9
	],
	"./Content/Type/List/List-documentation.md": [
		1061,
		9
	],
	"./Content/Type/List/index": [
		321,
		9
	],
	"./Content/Type/List/index.js": [
		321,
		9
	],
	"./Content/View": [
		389,
		9
	],
	"./Content/View/": [
		389,
		9
	],
	"./Content/View/View-documentation.md": [
		1062,
		9
	],
	"./Content/View/index": [
		389,
		9
	],
	"./Content/View/index.jsx": [
		389,
		9
	],
	"./DailyRecord/Create": [
		322,
		9
	],
	"./DailyRecord/Create/": [
		322,
		9
	],
	"./DailyRecord/Create/Create-documentation.md": [
		1063,
		9
	],
	"./DailyRecord/Create/index": [
		322,
		9
	],
	"./DailyRecord/Create/index.jsx": [
		322,
		9
	],
	"./DailyRecord/Create/style.css": [
		743,
		7
	],
	"./DailyRecord/Edit": [
		323,
		9
	],
	"./DailyRecord/Edit/": [
		323,
		9
	],
	"./DailyRecord/Edit/Edit-documentation.md": [
		1064,
		9
	],
	"./DailyRecord/Edit/index": [
		323,
		9
	],
	"./DailyRecord/Edit/index.jsx": [
		323,
		9
	],
	"./DailyRecord/Edit/style.css": [
		1065,
		7
	],
	"./DailyRecord/List": [
		324,
		9
	],
	"./DailyRecord/List/": [
		324,
		9
	],
	"./DailyRecord/List/List-documentation.md": [
		1066,
		9
	],
	"./DailyRecord/List/index": [
		324,
		9
	],
	"./DailyRecord/List/index.jsx": [
		324,
		9
	],
	"./DailyRecord/View": [
		325,
		9
	],
	"./DailyRecord/View/": [
		325,
		9
	],
	"./DailyRecord/View/View-documentation.md": [
		1067,
		9
	],
	"./DailyRecord/View/index": [
		325,
		9
	],
	"./DailyRecord/View/index.jsx": [
		325,
		9
	],
	"./Dashboard": [
		326,
		9
	],
	"./Dashboard/": [
		326,
		9
	],
	"./Dashboard/Dashboard-documentation.md": [
		1068,
		9
	],
	"./Dashboard/index": [
		326,
		9
	],
	"./Dashboard/index.js": [
		326,
		9
	],
	"./DigitalBooks/List": [
		327,
		9
	],
	"./DigitalBooks/List/": [
		327,
		9
	],
	"./DigitalBooks/List/index": [
		327,
		9
	],
	"./DigitalBooks/List/index.jsx": [
		327,
		9
	],
	"./DigitalBooks/List/styles.css": [
		744,
		7
	],
	"./Education/Curriculum/Create": [
		328,
		9
	],
	"./Education/Curriculum/Create/": [
		328,
		9
	],
	"./Education/Curriculum/Create/Create-documentation.md": [
		1069,
		9
	],
	"./Education/Curriculum/Create/index": [
		328,
		9
	],
	"./Education/Curriculum/Create/index.js": [
		328,
		9
	],
	"./Education/Curriculum/List": [
		329,
		9
	],
	"./Education/Curriculum/List/": [
		329,
		9
	],
	"./Education/Curriculum/List/List-documentation.md": [
		1070,
		9
	],
	"./Education/Curriculum/List/index": [
		329,
		9
	],
	"./Education/Curriculum/List/index.js": [
		329,
		9
	],
	"./Education/CurriculumReport": [
		397,
		9
	],
	"./Education/CurriculumReport/": [
		397,
		9
	],
	"./Education/CurriculumReport/Report-documentation.md": [
		1071,
		9
	],
	"./Education/CurriculumReport/index": [
		397,
		9
	],
	"./Education/CurriculumReport/index.jsx": [
		397,
		9
	],
	"./Education/Method/Create": [
		330,
		9
	],
	"./Education/Method/Create/": [
		330,
		9
	],
	"./Education/Method/Create/Create-documentation.md": [
		1072,
		9
	],
	"./Education/Method/Create/index": [
		330,
		9
	],
	"./Education/Method/Create/index.js": [
		330,
		9
	],
	"./Education/Method/List": [
		331,
		9
	],
	"./Education/Method/List/": [
		331,
		9
	],
	"./Education/Method/List/List-documentation.md": [
		1073,
		9
	],
	"./Education/Method/List/index": [
		331,
		9
	],
	"./Education/Method/List/index.js": [
		331,
		9
	],
	"./Education/Period/Create": [
		332,
		9
	],
	"./Education/Period/Create/": [
		332,
		9
	],
	"./Education/Period/Create/Create-documentation.md": [
		1074,
		9
	],
	"./Education/Period/Create/index": [
		332,
		9
	],
	"./Education/Period/Create/index.js": [
		332,
		9
	],
	"./Education/Period/List": [
		333,
		9
	],
	"./Education/Period/List/": [
		333,
		9
	],
	"./Education/Period/List/List-documentation.md": [
		1075,
		9
	],
	"./Education/Period/List/index": [
		333,
		9
	],
	"./Education/Period/List/index.js": [
		333,
		9
	],
	"./Education/Resource/Create": [
		334,
		9
	],
	"./Education/Resource/Create/": [
		334,
		9
	],
	"./Education/Resource/Create/Create-documentation.md": [
		1076,
		9
	],
	"./Education/Resource/Create/index": [
		334,
		9
	],
	"./Education/Resource/Create/index.js": [
		334,
		9
	],
	"./Education/Resource/List": [
		335,
		9
	],
	"./Education/Resource/List/": [
		335,
		9
	],
	"./Education/Resource/List/List-documentation.md": [
		1077,
		9
	],
	"./Education/Resource/List/index": [
		335,
		9
	],
	"./Education/Resource/List/index.js": [
		335,
		9
	],
	"./Emotions/List": [
		393,
		9
	],
	"./Emotions/List/": [
		393,
		9
	],
	"./Emotions/List/List-documentation.md": [
		1078,
		9
	],
	"./Emotions/List/index": [
		393,
		9
	],
	"./Emotions/List/index.jsx": [
		393,
		9
	],
	"./Evaluation/ADR/Allocate": [
		336,
		9
	],
	"./Evaluation/ADR/Allocate/": [
		336,
		9
	],
	"./Evaluation/ADR/Allocate/index": [
		336,
		9
	],
	"./Evaluation/ADR/Allocate/index.jsx": [
		336,
		9
	],
	"./Evaluation/ADR/Allocate/style.css": [
		745,
		7
	],
	"./Evaluation/ADR/AllocateList": [
		337,
		9
	],
	"./Evaluation/ADR/AllocateList/": [
		337,
		9
	],
	"./Evaluation/ADR/AllocateList/index": [
		337,
		9
	],
	"./Evaluation/ADR/AllocateList/index.jsx": [
		337,
		9
	],
	"./Evaluation/ADR/Bank": [
		338,
		9
	],
	"./Evaluation/ADR/Bank/": [
		338,
		9
	],
	"./Evaluation/ADR/Bank/index": [
		338,
		9
	],
	"./Evaluation/ADR/Bank/index.jsx": [
		338,
		9
	],
	"./Evaluation/ADR/Create": [
		339,
		9
	],
	"./Evaluation/ADR/Create/": [
		339,
		9
	],
	"./Evaluation/ADR/Create/index": [
		339,
		9
	],
	"./Evaluation/ADR/Create/index.js": [
		339,
		9
	],
	"./Evaluation/ADR/List": [
		340,
		9
	],
	"./Evaluation/ADR/List/": [
		340,
		9
	],
	"./Evaluation/ADR/List/index": [
		340,
		9
	],
	"./Evaluation/ADR/List/index.js": [
		340,
		9
	],
	"./Evaluation/ADR/List/statistics": [
		479,
		9
	],
	"./Evaluation/ADR/List/statistics.jsx": [
		479,
		9
	],
	"./Evaluation/ADR/List/style.css": [
		747,
		7
	],
	"./Evaluation/ADR/Report": [
		341,
		9
	],
	"./Evaluation/ADR/Report/": [
		341,
		9
	],
	"./Evaluation/ADR/Report/index": [
		341,
		9
	],
	"./Evaluation/ADR/Report/index.jsx": [
		341,
		9
	],
	"./Evaluation/ADR/Report/style.css": [
		748,
		7
	],
	"./Evaluation/ADR/Schedule": [
		342,
		9
	],
	"./Evaluation/ADR/Schedule/": [
		342,
		9
	],
	"./Evaluation/ADR/Schedule/index": [
		342,
		9
	],
	"./Evaluation/ADR/Schedule/index.jsx": [
		342,
		9
	],
	"./Evaluation/Allocate": [
		343,
		9
	],
	"./Evaluation/Allocate/": [
		343,
		9
	],
	"./Evaluation/Allocate/Allocate-documentation.md": [
		1079,
		9
	],
	"./Evaluation/Allocate/index": [
		343,
		9
	],
	"./Evaluation/Allocate/index.jsx": [
		343,
		9
	],
	"./Evaluation/Allocate/style.css": [
		749,
		7
	],
	"./Evaluation/Bank/Allocate": [
		344,
		9
	],
	"./Evaluation/Bank/Allocate/": [
		344,
		9
	],
	"./Evaluation/Bank/Allocate/index": [
		344,
		9
	],
	"./Evaluation/Bank/Allocate/index.jsx": [
		344,
		9
	],
	"./Evaluation/Bank/Allocate/style.css": [
		750,
		7
	],
	"./Evaluation/Bank/GradePanel": [
		406,
		9
	],
	"./Evaluation/Bank/GradePanel/": [
		406,
		9
	],
	"./Evaluation/Bank/GradePanel/index": [
		406,
		9
	],
	"./Evaluation/Bank/GradePanel/index.jsx": [
		406,
		9
	],
	"./Evaluation/Bank/GradePanel/styles.css": [
		751,
		7
	],
	"./Evaluation/Bank/List": [
		345,
		9
	],
	"./Evaluation/Bank/List/": [
		345,
		9
	],
	"./Evaluation/Bank/List/index": [
		345,
		9
	],
	"./Evaluation/Bank/List/index.jsx": [
		345,
		9
	],
	"./Evaluation/Bank/Statistics": [
		346,
		9
	],
	"./Evaluation/Bank/Statistics/": [
		346,
		9
	],
	"./Evaluation/Bank/Statistics/index": [
		346,
		9
	],
	"./Evaluation/Bank/Statistics/index.jsx": [
		346,
		9
	],
	"./Evaluation/Bank/StudentStatistics": [
		347,
		9
	],
	"./Evaluation/Bank/StudentStatistics/": [
		347,
		9
	],
	"./Evaluation/Bank/StudentStatistics/index": [
		347,
		9
	],
	"./Evaluation/Bank/StudentStatistics/index.jsx": [
		347,
		9
	],
	"./Evaluation/Create": [
		348,
		9
	],
	"./Evaluation/Create/": [
		348,
		9
	],
	"./Evaluation/Create/Create-documentation.md": [
		1080,
		9
	],
	"./Evaluation/Create/index": [
		348,
		9
	],
	"./Evaluation/Create/index.jsx": [
		348,
		9
	],
	"./Evaluation/List": [
		349,
		9
	],
	"./Evaluation/List/": [
		349,
		9
	],
	"./Evaluation/List/List-documentation.md": [
		1081,
		9
	],
	"./Evaluation/List/index": [
		349,
		9
	],
	"./Evaluation/List/index.js": [
		349,
		9
	],
	"./Evaluation/List/statistics": [
		149,
		9
	],
	"./Evaluation/List/statistics.jsx": [
		149,
		9
	],
	"./Evaluation/List/style.css": [
		746,
		7
	],
	"./Evaluation/Print": [
		350,
		9
	],
	"./Evaluation/Print/": [
		350,
		9
	],
	"./Evaluation/Print/Print-documentation.md": [
		1082,
		9
	],
	"./Evaluation/Print/index": [
		350,
		9
	],
	"./Evaluation/Print/index.jsx": [
		350,
		9
	],
	"./Evaluation/Question/Bank": [
		351,
		9
	],
	"./Evaluation/Question/Bank/": [
		351,
		9
	],
	"./Evaluation/Question/Bank/Bank-documentation.md": [
		1083,
		9
	],
	"./Evaluation/Question/Bank/Review/Edit": [
		394,
		9
	],
	"./Evaluation/Question/Bank/Review/Edit/": [
		394,
		9
	],
	"./Evaluation/Question/Bank/Review/Edit/index": [
		394,
		9
	],
	"./Evaluation/Question/Bank/Review/Edit/index.jsx": [
		394,
		9
	],
	"./Evaluation/Question/Bank/Review/Edit/styles.css": [
		753,
		7
	],
	"./Evaluation/Question/Bank/Review/List": [
		352,
		9
	],
	"./Evaluation/Question/Bank/Review/List/": [
		352,
		9
	],
	"./Evaluation/Question/Bank/Review/List/index": [
		352,
		9
	],
	"./Evaluation/Question/Bank/Review/List/index.jsx": [
		352,
		9
	],
	"./Evaluation/Question/Bank/index": [
		351,
		9
	],
	"./Evaluation/Question/Bank/index.jsx": [
		351,
		9
	],
	"./Evaluation/Question/Bank/styles.css": [
		752,
		7
	],
	"./Evaluation/Question/Create": [
		191,
		9
	],
	"./Evaluation/Question/Create/": [
		191,
		9
	],
	"./Evaluation/Question/Create/Create-documentation.md": [
		1084,
		9
	],
	"./Evaluation/Question/Create/index": [
		191,
		9
	],
	"./Evaluation/Question/Create/index.js": [
		191,
		9
	],
	"./Evaluation/Question/Create/styles.css": [
		698,
		7
	],
	"./Evaluation/Question/List": [
		353,
		9
	],
	"./Evaluation/Question/List/": [
		353,
		9
	],
	"./Evaluation/Question/List/List-documentation.md": [
		1085,
		9
	],
	"./Evaluation/Question/List/index": [
		353,
		9
	],
	"./Evaluation/Question/List/index.js": [
		353,
		9
	],
	"./Evaluation/Question/Prototype": [
		354,
		9
	],
	"./Evaluation/Question/Prototype/": [
		354,
		9
	],
	"./Evaluation/Question/Prototype/Prototype-documentation.md": [
		1086,
		9
	],
	"./Evaluation/Question/Prototype/index": [
		354,
		9
	],
	"./Evaluation/Question/Prototype/index.js": [
		354,
		9
	],
	"./Evaluation/QuestionList/Do": [
		190,
		9
	],
	"./Evaluation/QuestionList/Do/": [
		190,
		9
	],
	"./Evaluation/QuestionList/Do/index": [
		190,
		9
	],
	"./Evaluation/QuestionList/Do/index.js": [
		190,
		9
	],
	"./Evaluation/QuestionList/Do/styles.css": [
		699,
		7
	],
	"./Evaluation/QuestionList/List": [
		355,
		9
	],
	"./Evaluation/QuestionList/List/": [
		355,
		9
	],
	"./Evaluation/QuestionList/List/List-documentation.md": [
		1087,
		9
	],
	"./Evaluation/QuestionList/List/index": [
		355,
		9
	],
	"./Evaluation/QuestionList/List/index.js": [
		355,
		9
	],
	"./Evaluation/QuestionList/Prototype": [
		356,
		9
	],
	"./Evaluation/QuestionList/Prototype/": [
		356,
		9
	],
	"./Evaluation/QuestionList/Prototype/index": [
		356,
		9
	],
	"./Evaluation/QuestionList/Prototype/index.js": [
		356,
		9
	],
	"./Evaluation/Tv": [
		407,
		9
	],
	"./Evaluation/Tv/": [
		407,
		9
	],
	"./Evaluation/Tv/Tv-documentation.md": [
		1088,
		9
	],
	"./Evaluation/Tv/index": [
		407,
		9
	],
	"./Evaluation/Tv/index.js": [
		407,
		9
	],
	"./Evaluation/Tv/style.css": [
		754,
		7
	],
	"./Evaluation/TypeQuestion/Create": [
		357,
		9
	],
	"./Evaluation/TypeQuestion/Create/": [
		357,
		9
	],
	"./Evaluation/TypeQuestion/Create/Create-documentation.md": [
		1089,
		9
	],
	"./Evaluation/TypeQuestion/Create/index": [
		357,
		9
	],
	"./Evaluation/TypeQuestion/Create/index.js": [
		357,
		9
	],
	"./Evaluation/TypeQuestion/List": [
		358,
		9
	],
	"./Evaluation/TypeQuestion/List/": [
		358,
		9
	],
	"./Evaluation/TypeQuestion/List/List-documentation.md": [
		1090,
		9
	],
	"./Evaluation/TypeQuestion/List/index": [
		358,
		9
	],
	"./Evaluation/TypeQuestion/List/index.js": [
		358,
		9
	],
	"./ExternalAuth": [
		175,
		9
	],
	"./ExternalAuth/": [
		175,
		9
	],
	"./ExternalAuth/ExternalAuth-documentation.md": [
		1091,
		9
	],
	"./ExternalAuth/index": [
		175,
		9
	],
	"./ExternalAuth/index.jsx": [
		175,
		9
	],
	"./ForgotPassword": [
		186,
		9
	],
	"./ForgotPassword/": [
		186,
		9
	],
	"./ForgotPassword/ForgotPassword-documentation.md": [
		1092,
		9
	],
	"./ForgotPassword/index": [
		186,
		9
	],
	"./ForgotPassword/index.jsx": [
		186,
		9
	],
	"./Guest": [
		187,
		9
	],
	"./Guest/": [
		187,
		9
	],
	"./Guest/Guest-documentation.md": [
		1093,
		9
	],
	"./Guest/index": [
		187,
		9
	],
	"./Guest/index.js": [
		187,
		9
	],
	"./Guest/style.css": [
		673,
		7
	],
	"./Help/Faq/Create": [
		359,
		9
	],
	"./Help/Faq/Create/": [
		359,
		9
	],
	"./Help/Faq/Create/Create-documentation.md": [
		1094,
		9
	],
	"./Help/Faq/Create/index": [
		359,
		9
	],
	"./Help/Faq/Create/index.js": [
		359,
		9
	],
	"./Help/Faq/List": [
		360,
		9
	],
	"./Help/Faq/List/": [
		360,
		9
	],
	"./Help/Faq/List/List-documentation.md": [
		1095,
		9
	],
	"./Help/Faq/List/index": [
		360,
		9
	],
	"./Help/Faq/List/index.js": [
		360,
		9
	],
	"./Help/Faq/Show": [
		361,
		9
	],
	"./Help/Faq/Show/": [
		361,
		9
	],
	"./Help/Faq/Show/Show-documentation.md": [
		1096,
		9
	],
	"./Help/Faq/Show/index": [
		361,
		9
	],
	"./Help/Faq/Show/index.js": [
		361,
		9
	],
	"./Help/Helpdesk/Category/Create": [
		362,
		9
	],
	"./Help/Helpdesk/Category/Create/": [
		362,
		9
	],
	"./Help/Helpdesk/Category/Create/Create-documentation.md": [
		1097,
		9
	],
	"./Help/Helpdesk/Category/Create/index": [
		362,
		9
	],
	"./Help/Helpdesk/Category/Create/index.js": [
		362,
		9
	],
	"./Help/Helpdesk/Category/List": [
		363,
		9
	],
	"./Help/Helpdesk/Category/List/": [
		363,
		9
	],
	"./Help/Helpdesk/Category/List/List-documentation.md": [
		1098,
		9
	],
	"./Help/Helpdesk/Category/List/index": [
		363,
		9
	],
	"./Help/Helpdesk/Category/List/index.js": [
		363,
		9
	],
	"./Help/Helpdesk/List": [
		364,
		9
	],
	"./Help/Helpdesk/List/": [
		364,
		9
	],
	"./Help/Helpdesk/List/List-documentation.md": [
		1099,
		9
	],
	"./Help/Helpdesk/List/index": [
		364,
		9
	],
	"./Help/Helpdesk/List/index.js": [
		364,
		9
	],
	"./Help/Helpdesk/List/style.css": [
		755,
		7
	],
	"./Help/Helpdesk/Me": [
		365,
		9
	],
	"./Help/Helpdesk/Me/": [
		365,
		9
	],
	"./Help/Helpdesk/Me/Me-documentation.md": [
		1100,
		9
	],
	"./Help/Helpdesk/Me/index": [
		365,
		9
	],
	"./Help/Helpdesk/Me/index.js": [
		365,
		9
	],
	"./Help/Helpdesk/Me/style.css": [
		756,
		7
	],
	"./Help/Helpdesk/Show": [
		366,
		9
	],
	"./Help/Helpdesk/Show/": [
		366,
		9
	],
	"./Help/Helpdesk/Show/Show-documentation.md": [
		1101,
		9
	],
	"./Help/Helpdesk/Show/index": [
		366,
		9
	],
	"./Help/Helpdesk/Show/index.js": [
		366,
		9
	],
	"./Help/Helpdesk/Show/style.css": [
		757,
		7
	],
	"./Help/Tutorials": [
		408,
		9
	],
	"./Help/Tutorials/": [
		408,
		9
	],
	"./Help/Tutorials/Tutorials-documentation.md": [
		1102,
		9
	],
	"./Help/Tutorials/index": [
		408,
		9
	],
	"./Help/Tutorials/index.jsx": [
		408,
		9
	],
	"./Import": [
		409,
		9
	],
	"./Import/": [
		409,
		9
	],
	"./Import/Import-documentation.md": [
		1103,
		9
	],
	"./Import/ImportAllocateStudents": [
		367,
		9
	],
	"./Import/ImportAllocateStudents/": [
		367,
		9
	],
	"./Import/ImportAllocateStudents/index": [
		367,
		9
	],
	"./Import/ImportAllocateStudents/index.js": [
		367,
		9
	],
	"./Import/ImportAllocateStudents/style.css": [
		758,
		7
	],
	"./Import/Students": [
		368,
		9
	],
	"./Import/Students/": [
		368,
		9
	],
	"./Import/Students/index": [
		368,
		9
	],
	"./Import/Students/index.js": [
		368,
		9
	],
	"./Import/Students/style.css": [
		759,
		7
	],
	"./Import/index": [
		409,
		9
	],
	"./Import/index.js": [
		409,
		9
	],
	"./Import/indexLegacy": [
		586,
		9
	],
	"./Import/indexLegacy.js": [
		586,
		9
	],
	"./Import/style.css": [
		585,
		7
	],
	"./LessonPlans": [
		369,
		9
	],
	"./LessonPlans/": [
		369,
		9
	],
	"./LessonPlans/View": [
		410,
		9
	],
	"./LessonPlans/View/": [
		410,
		9
	],
	"./LessonPlans/View/index": [
		410,
		9
	],
	"./LessonPlans/View/index.jsx": [
		410,
		9
	],
	"./LessonPlans/index": [
		369,
		9
	],
	"./LessonPlans/index.jsx": [
		369,
		9
	],
	"./Login": [
		188,
		9
	],
	"./Login/": [
		188,
		9
	],
	"./Login/Login-documentation.md": [
		1104,
		9
	],
	"./Login/LoginExternal": [
		470,
		9
	],
	"./Login/LoginExternal.jsx": [
		470,
		9
	],
	"./Login/index": [
		188,
		9
	],
	"./Login/index.js": [
		188,
		9
	],
	"./Logout": [
		189,
		9
	],
	"./Logout/": [
		189,
		9
	],
	"./Logout/Logout-documentation.md": [
		1105,
		9
	],
	"./Logout/index": [
		189,
		9
	],
	"./Logout/index.js": [
		189,
		9
	],
	"./Logs": [
		411,
		9
	],
	"./Logs/": [
		411,
		9
	],
	"./Logs/Logs-documentation.md": [
		1106,
		9
	],
	"./Logs/index": [
		411,
		9
	],
	"./Logs/index.js": [
		411,
		9
	],
	"./Management": [
		412,
		9
	],
	"./Management/": [
		412,
		9
	],
	"./Management/Management-documentation.md": [
		1107,
		9
	],
	"./Management/index": [
		412,
		9
	],
	"./Management/index.js": [
		412,
		9
	],
	"./Management/style.scss": [
		587,
		7
	],
	"./Management/toRemove": [
		588,
		9
	],
	"./Management/toRemove.js": [
		588,
		9
	],
	"./News/Panel": [
		413,
		9
	],
	"./News/Panel/": [
		413,
		9
	],
	"./News/Panel/Panel-documentation.md": [
		1108,
		9
	],
	"./News/Panel/index": [
		413,
		9
	],
	"./News/Panel/index.jsx": [
		413,
		9
	],
	"./Offline/Register/Create": [
		370,
		9
	],
	"./Offline/Register/Create/": [
		370,
		9
	],
	"./Offline/Register/Create/Create-documentation.md": [
		1109,
		9
	],
	"./Offline/Register/Create/index": [
		370,
		9
	],
	"./Offline/Register/Create/index.jsx": [
		370,
		9
	],
	"./Offline/Register/Create/style.css": [
		760,
		7
	],
	"./Offline/Register/Edit": [
		371,
		9
	],
	"./Offline/Register/Edit/": [
		371,
		9
	],
	"./Offline/Register/Edit/Edit-documentation.md": [
		1110,
		9
	],
	"./Offline/Register/Edit/index": [
		371,
		9
	],
	"./Offline/Register/Edit/index.jsx": [
		371,
		9
	],
	"./Offline/Register/Edit/styles.css": [
		1111,
		7
	],
	"./Offline/Register/List": [
		414,
		9
	],
	"./Offline/Register/List/": [
		414,
		9
	],
	"./Offline/Register/List/List-documentation.md": [
		1112,
		9
	],
	"./Offline/Register/List/index": [
		414,
		9
	],
	"./Offline/Register/List/index.jsx": [
		414,
		9
	],
	"./Offline/Register/List/styles.css": [
		1113,
		7
	],
	"./Offline/Register/View": [
		372,
		9
	],
	"./Offline/Register/View/": [
		372,
		9
	],
	"./Offline/Register/View/View-documentation.md": [
		1114,
		9
	],
	"./Offline/Register/View/index": [
		372,
		9
	],
	"./Offline/Register/View/index.jsx": [
		372,
		9
	],
	"./Olympics/Activity": [
		373,
		9
	],
	"./Olympics/Activity/": [
		373,
		9
	],
	"./Olympics/Activity/index": [
		373,
		9
	],
	"./Olympics/Activity/index.jsx": [
		373,
		9
	],
	"./Olympics/Conecta.png": [
		423,
		9
	],
	"./Olympics/Dashboard": [
		415,
		9
	],
	"./Olympics/Dashboard/": [
		415,
		9
	],
	"./Olympics/Dashboard/index": [
		415,
		9
	],
	"./Olympics/Dashboard/index.js": [
		415,
		9
	],
	"./Olympics/Dashboard/styles.css": [
		761,
		7
	],
	"./Olympics/Leaderboard/School": [
		374,
		9
	],
	"./Olympics/Leaderboard/School/": [
		374,
		9
	],
	"./Olympics/Leaderboard/School/index": [
		374,
		9
	],
	"./Olympics/Leaderboard/School/index.js": [
		374,
		9
	],
	"./Olympics/Leaderboard/Student": [
		375,
		9
	],
	"./Olympics/Leaderboard/Student/": [
		375,
		9
	],
	"./Olympics/Leaderboard/Student/index": [
		375,
		9
	],
	"./Olympics/Leaderboard/Student/index.js": [
		375,
		9
	],
	"./Olympics/List": [
		376,
		9
	],
	"./Olympics/List/": [
		376,
		9
	],
	"./Olympics/List/index": [
		376,
		9
	],
	"./Olympics/List/index.js": [
		376,
		9
	],
	"./PDF": [
		390,
		9
	],
	"./PDF/": [
		390,
		9
	],
	"./PDF/PDF-documentation.md": [
		1116,
		9
	],
	"./PDF/index": [
		390,
		9
	],
	"./PDF/index.jsx": [
		390,
		9
	],
	"./PedagogicalFollowUps": [
		416,
		9
	],
	"./PedagogicalFollowUps/": [
		416,
		9
	],
	"./PedagogicalFollowUps/Allocate": [
		377,
		9
	],
	"./PedagogicalFollowUps/Allocate/": [
		377,
		9
	],
	"./PedagogicalFollowUps/Allocate/index": [
		377,
		9
	],
	"./PedagogicalFollowUps/Allocate/index.jsx": [
		377,
		9
	],
	"./PedagogicalFollowUps/Consolidated": [
		378,
		9
	],
	"./PedagogicalFollowUps/Consolidated/": [
		378,
		9
	],
	"./PedagogicalFollowUps/Consolidated/index": [
		378,
		9
	],
	"./PedagogicalFollowUps/Consolidated/index.jsx": [
		378,
		9
	],
	"./PedagogicalFollowUps/Consolidated/newConsolidated": [
		379,
		9
	],
	"./PedagogicalFollowUps/Consolidated/newConsolidated/": [
		379,
		9
	],
	"./PedagogicalFollowUps/Consolidated/newConsolidated/index": [
		379,
		9
	],
	"./PedagogicalFollowUps/Consolidated/newConsolidated/index.jsx": [
		379,
		9
	],
	"./PedagogicalFollowUps/Consolidated/newConsolidated/styles.css": [
		763,
		7
	],
	"./PedagogicalFollowUps/Consolidated/styles.css": [
		762,
		7
	],
	"./PedagogicalFollowUps/Create": [
		417,
		9
	],
	"./PedagogicalFollowUps/Create/": [
		417,
		9
	],
	"./PedagogicalFollowUps/Create/index": [
		417,
		9
	],
	"./PedagogicalFollowUps/Create/index.jsx": [
		417,
		9
	],
	"./PedagogicalFollowUps/Execution": [
		380,
		9
	],
	"./PedagogicalFollowUps/Execution/": [
		380,
		9
	],
	"./PedagogicalFollowUps/Execution/Room": [
		381,
		9
	],
	"./PedagogicalFollowUps/Execution/Room/": [
		381,
		9
	],
	"./PedagogicalFollowUps/Execution/Room/index": [
		381,
		9
	],
	"./PedagogicalFollowUps/Execution/Room/index.jsx": [
		381,
		9
	],
	"./PedagogicalFollowUps/Execution/Room/styles.css": [
		765,
		7
	],
	"./PedagogicalFollowUps/Execution/index": [
		380,
		9
	],
	"./PedagogicalFollowUps/Execution/index.jsx": [
		380,
		9
	],
	"./PedagogicalFollowUps/Execution/styles.css": [
		764,
		7
	],
	"./PedagogicalFollowUps/List": [
		382,
		9
	],
	"./PedagogicalFollowUps/List/": [
		382,
		9
	],
	"./PedagogicalFollowUps/List/index": [
		382,
		9
	],
	"./PedagogicalFollowUps/List/index.jsx": [
		382,
		9
	],
	"./PedagogicalFollowUps/index": [
		416,
		9
	],
	"./PedagogicalFollowUps/index.jsx": [
		416,
		9
	],
	"./PendingLOs/List": [
		398,
		9
	],
	"./PendingLOs/List/": [
		398,
		9
	],
	"./PendingLOs/List/List-documentation.md": [
		1117,
		9
	],
	"./PendingLOs/List/index": [
		398,
		9
	],
	"./PendingLOs/List/index.jsx": [
		398,
		9
	],
	"./Profile": [
		399,
		9
	],
	"./Profile/": [
		399,
		9
	],
	"./Profile/Profile-documentation.md": [
		1118,
		9
	],
	"./Profile/SummaryStudent": [
		383,
		9
	],
	"./Profile/SummaryStudent/": [
		383,
		9
	],
	"./Profile/SummaryStudent/index": [
		383,
		9
	],
	"./Profile/SummaryStudent/index.jsx": [
		383,
		9
	],
	"./Profile/SummaryStudent/styles.css": [
		767,
		7
	],
	"./Profile/index": [
		399,
		9
	],
	"./Profile/index.js": [
		399,
		9
	],
	"./Profile/styles.css": [
		766,
		7
	],
	"./Report/Access": [
		384,
		9
	],
	"./Report/Access/": [
		384,
		9
	],
	"./Report/Access/Access-documentation.md": [
		1119,
		9
	],
	"./Report/Access/index": [
		384,
		9
	],
	"./Report/Access/index.jsx": [
		384,
		9
	],
	"./Report/Trails": [
		385,
		9
	],
	"./Report/Trails/": [
		385,
		9
	],
	"./Report/Trails/index": [
		385,
		9
	],
	"./Report/Trails/index.jsx": [
		385,
		9
	],
	"./Report/Trails/styles.css": [
		768,
		7
	],
	"./Root": [
		480,
		9
	],
	"./Root.js": [
		480,
		9
	],
	"./Stift/View": [
		418,
		9
	],
	"./Stift/View/": [
		418,
		9
	],
	"./Stift/View/View-documentation.md": [
		1120,
		9
	],
	"./Stift/View/index": [
		418,
		9
	],
	"./Stift/View/index.js": [
		418,
		9
	],
	"./Tools/Gerador/Create": [
		386,
		9
	],
	"./Tools/Gerador/Create/": [
		386,
		9
	],
	"./Tools/Gerador/Create/Create-documentation.md": [
		1121,
		9
	],
	"./Tools/Gerador/Create/index": [
		386,
		9
	],
	"./Tools/Gerador/Create/index.jsx": [
		386,
		9
	],
	"./Tools/Gerador/Gerador-documentation.md": [
		1122,
		9
	],
	"./Tools/Gerador/List": [
		387,
		9
	],
	"./Tools/Gerador/List/": [
		387,
		9
	],
	"./Tools/Gerador/List/List-documentation.md": [
		1123,
		9
	],
	"./Tools/Gerador/List/index": [
		387,
		9
	],
	"./Tools/Gerador/List/index.jsx": [
		387,
		9
	],
	"./Tools/Gerador/Show": [
		388,
		9
	],
	"./Tools/Gerador/Show/": [
		388,
		9
	],
	"./Tools/Gerador/Show/Show-documentation.md": [
		1124,
		9
	],
	"./Tools/Gerador/Show/index": [
		388,
		9
	],
	"./Tools/Gerador/Show/index.jsx": [
		388,
		9
	],
	"./Tools/Literarte": [
		392,
		9
	],
	"./Tools/Literarte/": [
		392,
		9
	],
	"./Tools/Literarte/Literarte-documentation.md": [
		1125,
		9
	],
	"./Tools/Literarte/index": [
		392,
		9
	],
	"./Tools/Literarte/index.jsx": [
		392,
		9
	],
	"./Tools/Newton": [
		419,
		9
	],
	"./Tools/Newton/": [
		419,
		9
	],
	"./Tools/Newton/Newton-documentation.md": [
		1126,
		9
	],
	"./Tools/Newton/index": [
		419,
		9
	],
	"./Tools/Newton/index.js": [
		419,
		9
	],
	"./Tools/Newton/style.css": [
		769,
		7
	],
	"./styles.css": [
		770,
		7
	]
};

function webpackAsyncContext(req) {
	return Promise.resolve().then(function() {
		if(!__webpack_require__.o(map, req)) {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		}

		var ids = map[req], id = ids[0];
		return __webpack_require__.t(id, ids[1])
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = 1333;
module.exports = webpackAsyncContext;